import { render, staticRenderFns } from "./EmbedModal.vue?vue&type=template&id=5a9dfc34"
import script from "./EmbedModal.vue?vue&type=script&lang=js"
export * from "./EmbedModal.vue?vue&type=script&lang=js"
import style0 from "./EmbedModal.vue?vue&type=style&index=0&id=5a9dfc34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports